<template>
<div class="block">
  <!-- <router-link to="dashboard"> -->
    <div class="button is-fullwidth is-primary is-rounded" disabled>
      <span class="icon"><i class="fas fa-chart-simple"></i></span>
      <span class="">Dashboard</span>
    </div>
  <!-- </router-link> -->
</div>
<div class="block">
  <!-- <router-link to="locations"> -->
    <div class="button is-fullwidth is-primary is-rounded" disabled>
      <span class="icon"><i class="fas fa-location-pin"></i></span>
      <span class="">Locations</span>
    </div>
  <!-- </router-link> -->
</div>
<div class="block">
  <!-- <router-link to="devices"> -->
    <div class="button is-fullwidth is-primary is-rounded" disabled>
      <span class="icon"><i class="fas fa-microphone"></i></span>
      <span class="">Devices</span>
    </div>
  <!-- </router-link> -->
</div>
<div class="block">
  <router-link to="/sounds">
    <div class="button is-fullwidth is-primary is-rounded">
      <span class="icon"><i class="fas fa-file-audio"></i></span>
      <span class="">Sounds</span>
    </div>
  </router-link>
</div>


<div class="block" v-if="isAdmin && isDevDep">
  <router-link to="/editor">
    <div class="button is-fullwidth is-primary is-rounded">
      <span class="icon"><i class="fa-solid fa-pencil"></i></span>
      <span class="">Blog post editor</span>
    </div>
  </router-link>
</div>
</template>


<script>
import { mapGetters } from 'pinia'
import { useLogin } from '@/js/auth.js'
import { isDevelopDeployment } from '@/js/general.js'

export default {
    data(){
        return {
            name: "ContentMenu",
        }
    },
    computed: {
        ...mapGetters(useLogin, ["claims", "getRemaining", "tokens", "isAdmin", "isDevEnv"]),
        isDevDep: isDevelopDeployment,
    }
}
</script>
